// extracted by mini-css-extract-plugin
export default {"option-item":"styles_option-item__aEAAJ","group-label":"styles_group-label__QcAtL"};